import { LitElement, html } from "lit-element";

import { mimeType, getAllImages } from "../../../data/images";
import { SharedStyles } from "../../../styles/shared-styles";
import { image } from "../Resources/drawing-icons";
import { setBackgroundImage } from "../helpers";
export class DrawBackgroundImageModule extends LitElement {
	get MainTb() {
		return {
			value: "background",
			icon: image,
			text: "BG"
		};
	}

	Activate() {
		return this;
	}

	render() {
		return html`
            ${SharedStyles}
            <style>
                input[type="radio"] {
                    display: none;
                }

                .bg-selector {
                   margin-top: 3px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    overflow-y: auto;
                    width: 40px;
                }
        
                label {
                    display: block;
                   
                    cursor: pointer;
                    padding: 2px;
                }

                .img, 
                .no-bg {
                    width: 36px;
                    height: 35px;
                }

                .img {
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                }

                .no-bg {
                    text-align: center;
                    font-size: 12px;
                    line-height: 1.2;
                    padding: 4px;
                    display: block;
                    background: lightgrey;
                }

                .bg-selector input[type="radio"][checked] + label {
                    
                }
            </style>
            <style>
                ${this._items.map((i, index) => this._renderClass(i, index))}
            </style>

            <div class="bg-selector">
                ${this._renderNoBg()}
                ${this._items.map((i, index) => this._renderItem(i, index))}
            </div>`;
	}

	_renderClass(i, index) {
		return html`.bg-item-${index} { background-image: url(${i.url}); }`;
	}

	_renderNoBg() {
		const id = "item_-1";
		const checked = !this.selectedValue;
		return html`
			<label for="${id}"  @click="${() => setBackgroundImage(null, this.canvas, this, this.drawingHistory)}">
				<span class="no-bg">No BG</span>
			</label>`;
	}

	_renderItem(i, index) {
		const id = "item_" + index;
		const checked = this.selectedValue === i.id;
		const cls = "bg-item-" + index;
		return html`
						<input type="radio" ?checked="${checked}" .checked="${checked}" @change="${() =>
	this.__setBg(i.id)}" name="items" id="${id}" .value="${i.id}">
						<label for="${id}">
							<div class="img ${cls}"></div>
						</label>`;
	}

	__setBg(id) {
		setBackgroundImage(id, this.canvas, this, this.drawingHistory);
	}

	firstUpdated() {
		getAllImages(INSP.APP.inspId)
			.then(images => {
				images.map(i => (i.url = this._createImageUrl(i)));
				this._items = images;
				this.requestUpdate();
			})
			.catch(a => console.log(a));
	}

	_createImageUrl(img) {
		const blob = new Blob([img.data], { type: img.dataMimeType || mimeType });
		return URL.createObjectURL(blob);
	}

	static get properties() {
		return {
			_items: Array,
			selectedValue: Number,
			inspId: String
		};
	}

	constructor(canvas, drawingHistory) {
		super();
		this.canvas = canvas;
		this._items = [];
		this.drawingHistory = drawingHistory;
	}
}

window.customElements.define(
	"inspx-draw-background-images",
	DrawBackgroundImageModule
);
